export const inp = "w-full bg-white/5 border border-white/15 rounded-lg px-3 py-2.5 text-sm focus:border-[#E63946] outline-none";

export const L = ({ children }) => (
  <label className="block text-xs uppercase tracking-[0.15em] text-white/40 mb-2">{children}</label>
);

export const Check = ({ label, checked, onChange, testid }) => (
  <label className="flex items-center gap-2.5 text-sm text-white/70 cursor-pointer select-none">
    <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid}
      className="w-4 h-4 accent-[#E63946]" />
    {label}
  </label>
);

export const Modal = ({ title, onClose, onSave, children, saveLabel = "Save", wide }) => (
  <div className="fixed inset-0 z-50 bg-black/70 grid place-items-center p-4 overflow-y-auto" onClick={onClose}>
    <div className={`bg-[#141414] border border-white/10 rounded-2xl w-full ${wide ? "max-w-2xl" : "max-w-lg"} my-8`} onClick={(e) => e.stopPropagation()}>
      <div className="flex items-center justify-between p-5 border-b border-white/10">
        <h3 className="font-display font-bold text-lg">{title}</h3>
        <button onClick={onClose} className="grid place-items-center w-9 h-9 rounded-full hover:bg-white/10 text-lg">×</button>
      </div>
      <div className="p-5 space-y-4 max-h-[65vh] overflow-y-auto">{children}</div>
      {onSave && (
        <div className="p-5 border-t border-white/10 flex justify-end gap-3">
          <button onClick={onClose} className="rounded-full border border-white/15 px-5 py-2.5 text-sm hover:bg-white/5">Cancel</button>
          <button onClick={onSave} data-testid="modal-save-btn" className="rounded-full bg-[#E63946] px-6 py-2.5 text-sm hover:bg-[#BA1B25] transition-colors">{saveLabel}</button>
        </div>
      )}
    </div>
  </div>
);

export const money = (v) => `$${Number(v || 0).toFixed(2)}`;
